import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
interface Props {
  image1?: IGatsbyImageDataObject
  image2?: IGatsbyImageDataObject
}
function PatternIntro(props: Props) {
  const { image1, image2 } = props
  return (
    <div className='py-12 et-grid-basic lg:pb-24 xl:pt-28 xl:pb-16'>


      {/* IMAGES BLOCK */}
      <div className='hidden col-span-8 col-start-9 row-start-1 md:block lg:col-start-9 lg:col-span-5 lg:ml-[-50px] lg:mr-[50px] xl:col-start-9 xl:col-span-5'>
        {image1 && <div className='relative w-full'>
          <GatsbyImage alt="image 1" image={image1.gatsbyImageData} className='w-full' />

          <div className='absolute top-[100px] right-[20%] w-[200px] lg:right-[-5%] lg:top-[125px] xl:right-[-10%] xl:top-[115px]'>
            <LazyLoadImage
              alt={
                'Magnetic snapping in Procreate.'
              }
              height={436}
              visibleByDefault={false}
              src={'https://et-teachable.imgix.net/procreate-patterns/magnetic-snapping.gif'} // use normal <img> attributes as props
              width={350} />
          </div>


        </div>}
      </div>

      {/* Content */}
      <div className='col-span-2 col-start-2 row-start-1 md:col-start-2 md:col-span-7 lg:col-start-3 lg:col-span-6 lg:ml-[-50px] lg:mr-[50px] xl:m-0 xl:col-start-2 xl:col-span-6'>
        <h2 className='section-h2 font-sentinel__SemiBoldItal'>
          Creating repeat patterns in Procreate is <span className='text-rusted-400'>hard.</span>
        </h2>
        <p className='mt-4 text-lg xl:text-xl'>
          Hard, and definitely not fun. There's remembering where things are repeating, which pattern type needs to repeat where - and <span className='italic font-bold'>ok, Procreate</span>. Thanks for the magnetic snapping that snaps to <span className='font-bold'>EVERYTHING</span>.
        </p>
      </div>

    </div>
  )
}

export default PatternIntro
